import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import axios from "axios";
import {ApiUrlUtil} from "app/utils/apiUrlUtil";
import {HeadersUtil} from "app/utils/headersUtil";
import {ResponseApi, ResponseResultCode} from "app/model/response-api";
import { CommonCode } from "app/model/common/code";

const initialState: { code: CommonCode } = {
  code: {
    ComUnit: [],
    EmksCntrKndCd: [],
    EmksCustTpClCd: [],
    EmksEntClCd: [],
    EmksEqpKndCd: [],
    EmksIndsCmplxClCd: [],
    EmksLdspTrdClCd: [],
    EmksMbrsClCd: [],
    EmksPrtclKndCd: [],
    EmksRe100JoinClCd: [],
    EmksRsrcClCd: [],
    MobileNumberPrefix: [],
  },
};

export const getCommonCode = createAsyncThunk("code/comCode", async() => {
  const url = process.env.REACT_APP_URL_CO + '/com/code';
  const response = await axios.get(ApiUrlUtil.buildQueryString(url), {
    headers: HeadersUtil.getHeadersAuth(),
  });

  if(response && "OK" === response.statusText) {
    return response.data;
  }
});

const codeSlice = createSlice({
  name: 'code',
  initialState,
  reducers: {

  },
  extraReducers: (builder) => {
    builder
    .addCase(getCommonCode.pending, () => {})
    .addCase(getCommonCode.fulfilled, (state, action: any) => {
      const response = action.payload as ResponseApi<CommonCode>;
      if(response && ResponseResultCode.Y === response.resultCode) {
        state.code = response.data;
      }
    })
    .addCase(getCommonCode.rejected, state => {
      state.code = initialState.code;
    })
  }
});

export default codeSlice.reducer;